function handleQueryParameters() {
    var queryStr = window.location.search;
    var paramPairs = queryStr.substr(1).split('&');
    var params = {};

    for (var i = 0; i < paramPairs.length; i++) {
        var parts = paramPairs[i].split('=');
        params[parts[0]] = parts[1];
        // ./beam-designer.html?login=true
        if (parts[0] == 'login' && parts[1] == 'true') {
            openSigninModal();
        } else if (parts[0] == 'sign-up' && parts[1] == 'true') {
            openSignupModal();
        }
    }
}

function customerGate() {
    if (customerLevel === "pro") {
        return false;
    }
    if (customerLevel === "basic") {
        openFinishUpgradeModal();
        return true;
    }
    // free or not set
    openSignupModal();
    return true;
}

window.onbeforeprint = function () {
    RedrawCanvas(true)
}

window.onafterprint = function () {
    RedrawCanvas(false)
}

window.addEventListener("beforeunload", function (e) {
    if (activeProject.isModified === false) {
        return undefined;
    }

    var confirmationMessage = 'Your project needs to be saved. '
        + 'If you leave before saving, your changes will be lost.';

    (e || window.event).returnValue = confirmationMessage; //Gecko + IE
    return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
});

document.addEventListener('north-american-steel-shapes-selected', () => {
    // update material selector modal
    document.getElementById('steel-material-tab').click()
})

document.addEventListener('european-steel-shapes-selected', () => {
    // update material selector modal
    document.getElementById('european-steel-material-tab').click()
})

document.addEventListener('wood-shapes-selected', () => {
    // update material selector modal
    document.getElementById('wood-material-tab').click()
})

document.addEventListener('north-american-steel-shape-selected', (event) => {
    const shape = event.detail
    designConfigurator.northAmericanSteelShape = shape;
    designConfigurator.northAmericanSteelSelected();
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('european-steel-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.europeanSteelShape = shape;
    designConfigurator.europeanSteelSelected();
    onShapeOrMaterialChanged();
    onNoDesignClick()
})

document.addEventListener('wood-shape-selected', (event) => {
    const shape = event.detail
    designConfigurator.woodShape = shape
    designConfigurator.woodSelected()
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
})

document.addEventListener('engineered-lumber-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.engineeredLumberShape = shape
    designConfigurator.engineeredLumberSelected()
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
})

document.addEventListener('flitch-updated', (event) => {
    const flitch = event.detail
    if (activeProject.isWood) {
        if (flitch) {
            designConfigurator.woodShape.flitch = flitch
        } else {
            delete designConfigurator.woodShape.flitch
        }
        designConfigurator.woodSelected()
    } else if (activeProject.isEngineeredLumber) {
        if (flitch) {
            designConfigurator.engineeredLumberShape.flitch = flitch
        } else {
            delete designConfigurator.engineeredLumberShape.flitch
        }
        designConfigurator.engineeredLumberSelected()
    }
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
})

document.addEventListener('custom-soldier-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.customSoldierShape = shape;
    designConfigurator.customSoldierSelected();
    onShapeOrMaterialChanged()
    onNoDesignClick()
    markBeamDesignNeedsSaved()
})

document.addEventListener('custom-aluminum-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.customAluminumShape = shape;
    designConfigurator.customAluminumSelected();
    onShapeOrMaterialChanged();
    onNoDesignClick()
})

document.addEventListener('custom-shape-selected', (event) => {
    if (customerGate()) { return; }
    const shape = event.detail
    designConfigurator.customShape = shape;
    designConfigurator.customMaterial = shape;
    designConfigurator.customShapeSelected();
    activeProject.design.designType = 'None';
    activeProject.customShape = shape;
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('custom-shape-unselected', () => {
    if (customerGate()) { return; }
    designConfigurator.northAmericanSteelSelected();
    activeProject.design.designType = 'None';
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('north-american-steel-material-selected', (event) => {
    const material = event.detail
    designConfigurator.northAmericanSteelMaterial = material;
    designConfigurator.northAmericanSteelSelected();
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('european-steel-material-selected', (event) => {
    if (customerGate()) { return; }
    const material = event.detail
    designConfigurator.europeanSteelMaterial = material;
    designConfigurator.europeanSteelSelected();
    activeProject.design.designType = 'None';
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('astm-steel-material-selected', (event) => {
    if (customerGate()) { return; }
    const material = event.detail
    designConfigurator.customSoldierMaterial = material;
    designConfigurator.customSoldierSelected();
    activeProject.design.designType = 'None';
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('aluminum-material-selected', (event) => {
    if (customerGate()) { return; }
    const material = event.detail
    designConfigurator.customAluminumMaterial = material;
    designConfigurator.customAluminumSelected();
    activeProject.design.designType = 'None';
    onShapeOrMaterialChanged();
    markBeamDesignNeedsSaved();
})

document.addEventListener('wood-material-selected', (event) => {
    const material = event.detail
    designConfigurator.woodMaterial = material
    designConfigurator.woodSelected()
    onShapeOrMaterialChanged()
    markBeamDesignNeedsSaved()
    $('#modal-material-selector-dialog').modal('toggle');
})

document.addEventListener('span-table-updated', () => {
    configureSpanButton()
})

document.addEventListener('load-added-or-updated', () => {
    configureLoadButton();
    updateLoadTable();
    autoBeamFlexureDesign();
})

document.addEventListener('bracing-changed', () => {
    configureBracingButton();
    autoBeamFlexureDesign();
})

document.addEventListener('design-type-changed', () => {
    configureDesignButton();
    autoBeamFlexureDesign();
})

document.addEventListener('design-deflection-limits-changed', () => {
    markBeamDesignNeedsSaved();
    autoBeamFlexureDesign();
});

document.addEventListener('span-length-changed', () => {
    updateLoadTable()
    autoBeamFlexureDesign();
})

document.addEventListener('on-logout-success', () => {
    resetActiveProject();
})


function configureShapeSelector() {
    if (activeProject.shape.flitch) {
        configureFlitchBeamForm(activeProject)
    }
}

function onShapeOrMaterialChanged() {
    activeProject.shape = designConfigurator.shape
    activeProject.material = designConfigurator.material
    activeProject.beam.crossSectionRotation = 0
    configureShapeButton()
    configureMaterialButton()
    configureDesignButton()
    configureShapeSelector()
    setUnits()
    RedrawCanvas()
    autoBeamFlexureDesign()
}

initSteelTable()
initEuropeanSteelTable()
initASTMSteelTable()
initAluminumTable()
initShapeTable()
initModalSpanDialog()

function setup() {    
    
    jQuery(".tm-input").tagsManager({
        backspace: [],
        maxTags: 10,
    });

    jQuery(".tm-input").on('tm:pushed', function (e, tag) {
        activeProject.tags = jQuery(".tm-input").tagsManager('tags');
        markBeamDesignNeedsSaved();
    });

    jQuery(".tm-input").on('tm:spliced', function (e, tag) {
        activeProject.tags = jQuery(".tm-input").tagsManager('tags');
        markBeamDesignNeedsSaved();
    });

    initializeDrawingCanvas()
    initLoadTable()
    initializeStripe()
    initializeFirebaseAuth()
    initializePrintPreferencesDialog()
    initializeProjectHeaderSettingsDialog()
    handleQueryParameters()
    resetBeamModelAndSetActiveProject()
    resizeCanvasArea()
    //RedrawCanvas()

}

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

function validateRequiredInput(elementId) {
    const el = document.getElementById(elementId)
    if (el.value !== null && el.value.trim() !== "") {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "This field is required."
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

function validateLengthInput(elementId) {
    const el = document.getElementById(elementId)
    if (!isNaN(wsParseLength(el.value))) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "Please enter a valid length unit. For example <code>5 in</code>, <code>5 inches</code> or <code>5\"</code>"
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

function validateLocation(elementId) {
    const el = document.getElementById(elementId)
    const location = wsParseLength(el.value)
    if (!isNaN(location) && location >= 0 && location <= activeProject.beam.TotalLength()) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "Position must be on the beam."
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

function validateMinimum(elementId, minimum) {
    const el = document.getElementById(elementId)
    if (!isNaN(parseFloat(el.value)) && parseFloat(el.value) >= minimum) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = `Number must be greater than or equal to ${minimum}`
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

function validateGreaterThan(elementId, minimum) {
    const el = document.getElementById(elementId)
    if (!isNaN(parseFloat(el.value)) && parseFloat(el.value) > minimum) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = `Number must be greater than to ${minimum}`
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

function validateBraceSpacing(elementId) {
    const el = document.getElementById(elementId)
    const value = el.value
    const spacing = wsParseLength(value)
    if (!isNaN(spacing) && spacing > 0 && spacing <= activeProject.beam.TotalLength()) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "Brace spacing must be larger than 0 and less than or equal to the total length of the beam."
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

function validateBraceLocation(elementId) {
    const el = document.getElementById(elementId)
    const value = el.value
    const spacing = wsParseLength(value)
    if (!isNaN(spacing) && spacing >= 0 && spacing <= activeProject.beam.TotalLength()) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = "Brace location must be greater than or equal to 0 and less than or equal to the total length of the beam."
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

function validateDistributedLoadPosition(startId, endId) {
    const start = wsParseLength(document.getElementById(startId).value)
    const end = wsParseLength(document.getElementById(endId).value)
    if (start < end) {
        const errorDiv = document.getElementById(`${endId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        let errorDiv = document.getElementById(`${endId}-error`)
        if (errorDiv === null) {
            errorDiv = document.createElement("div")
            errorDiv.id = `${endId}-error`
            document.getElementById(endId).parentElement.appendChild(errorDiv)
        }
        errorDiv.innerHTML = "Start position must be less than end position."
        return false
    }
}

function validateLoadMagnitude(elementId) {
    const el = document.getElementById(elementId)
    if (!isNaN(parseFloat(el.value)) && isFinite(el.value)) {
        const errorDiv = document.getElementById(`${elementId}-error`)
        if (errorDiv) { errorDiv.remove() }
        return true
    } else {
        const errorDiv = document.createElement("div")
        errorDiv.id = `${elementId}-error`
        errorDiv.innerHTML = `Must be a number and must be finite.`
        el.parentElement.appendChild(errorDiv)
        return false
    }
}

